import { Typography, Box, Grid, Divider, useTheme } from '@material-ui/core';
import { DataGrid, GridColumnProps } from '@roc/ui';
import { Link } from 'react-router-dom';
import { useLeadDetailsRoutes } from '../../routes/loanRoutes';
import { useBorrowerDetailsRoutes } from '../../routes/borrowerDetailsRoutes';
import { useTPOContactDetailsRoutes } from '../../routes/tpoContactDetailsRoutes';
import { insertIf } from '@roc/feature-utils';




const MetricPersonalInfromation = ({ records, showTotalColumn, eventDateColLabel }) => {

  const columns: GridColumnProps[] = [
    {
      field: 'name',
      headerName: 'Name',
      minWidth: 100,
      tooltipField: 'name',
      cellRenderer: 'leadNameCellRenderer',
      equals: () => false
    },
    {
      field: 'email',
      headerName: 'Email',
      minWidth: 100,
      tooltipField: 'email',
    },
    ...insertIf(eventDateColLabel, [
      {
        field: 'emailSubject',
        headerName: 'Subject',
        minWidth: 100,
        tooltipField: 'subject',
      },
      {
        field: 'eventDate',
        headerName: eventDateColLabel,
        minWidth: 100,
        tooltipField: 'eventDate',
      }
    ]),
    ...insertIf(showTotalColumn, [{
      field: 'totalAmount',
      headerName: 'Total',
      minWidth: 100,
      tooltipField: 'totalAmount',
    }]),
  ];

  const frameworkComponents = {
    leadNameCellRenderer: params => nameCellRenderer(params),
  };

  const getRouteConfigUrlForRecordType = (selectedId, recordType) => {
    const { leadDetailsRoutesConfig } = useLeadDetailsRoutes();
    const { borrowerDetailsRoutesConfig } = useBorrowerDetailsRoutes();
    const { tpoContactDetailsRoutesConfig } = useTPOContactDetailsRoutes();
    if (recordType) {
      if (recordType.includes('Lead')) {
        return leadDetailsRoutesConfig.leadDetails(selectedId).url;
      } else if (recordType.includes('Borrower')) {
        return borrowerDetailsRoutesConfig.borrowerDetails(selectedId).url;
      } else {
        return tpoContactDetailsRoutesConfig.tpoContactDetails(selectedId, recordType).url;
      }
    }

    return '';
  }

  const nameCellRenderer = (params) => {
    const { palette } = useTheme();
    const selectedId = params.node.data?.recordType === 'Lead' ? params.node.data?.leadId : params.node.data?.recordType === 'Borrower' ? params.node.data?.borrowerId : params.node.data?.companyContactId;
    const routeConfigUrl = getRouteConfigUrlForRecordType(selectedId, params.node.data?.recordType);

    return (
      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        <Link style={{ color: palette.primary.dark }}
          to={routeConfigUrl}
          target="_blank" rel="noopener noreferrer">
          <strong>{params.value}</strong>
        </Link>
      </div>
    )
  };


  if (!records || records.length === 0) {
    return <Typography>No records found.</Typography>;
  }

  return (
    <Grid item xs={12}>
      <DataGrid
        frameworkComponents={frameworkComponents}
        columns={columns}
        rows={records}
        domLayout="autoHeight"
      />
    </Grid>
  );
};

export default MetricPersonalInfromation;
